"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-StatusCollections',
    isLoading: 'c-StatusCollections--IsLoading',
    content: 'c-StatusCollections__Content',
    contentSecond: 'c-StatusCollections__Content__second',
    list: 'c-StatusCollections__List',
    menu: 'c-StatusCollections__Menu'
};
exports.Style = {
    [exports.CSS.container]: {
        width: '600px'
    },
    [exports.CSS.isLoading]: {
        display: 'flex',
        'justify-content': 'center'
    },
    [exports.CSS.content]: {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-around'
    },
    [exports.CSS.contentSecond]: {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-between'
    },
    [exports.CSS.list]: {
        'list-style-type': 'none',
        'padding-left': 0
    },
    [exports.CSS.menu]: {
        width: '600px',
        position: 'absolute',
        [`& .${menu_style_1.CSS.menu}`]: {
            right: 'auto',
            width: '100%'
        }
    }
};
//# sourceMappingURL=collection.status.modal.style.js.map